import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20.138 8.014 15.21c-1.663-.059-3.9.072-5.116-1.256C2.268 13.264 1.8 11.927 1.8 9c0-2.9.507-4.261 1.223-4.977S5.1 2.8 8 2.8h8c2.9 0 4.261.507 4.977 1.223S22.2 6.1 22.2 9c0 2.744-.457 4.111-1.116 4.854-1.217 1.37-3.408 1.294-5.099 1.358zM7.13 16.98 12 23l4.87-6.02C22.19 16.78 24 14.69 24 9c0-6-2-8-8-8H8C2 1 0 3 0 9s1.81 7.79 7.13 7.98M10.4 11H8.6c0 .71.295 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.448-.477.744-1.106.744-1.816h-1.8c0 .76-.984 1.1-1.6 1.1s-1.6-.34-1.6-1.1m3.35-4.25c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M8.5 5c-1.312 0-1.75.875-1.75 1.75S7.188 8.5 8.5 8.5s1.75-.875 1.75-1.75S9.813 5 8.5 5"
                fill="currentColor"
            />
        </g>
    </svg>
));
CompanysLifeOutlinedSize24Glyph.displayName = 'CompanysLifeOutlinedSize24Glyph';
